module.exports = __webpack_public_path__ + "static/tipsAndTricksDashBack-ebfd22e0049226178bfc9c84dec4a543.png";